import { render, staticRenderFns } from "./background.vue?vue&type=template&id=4e62acd6&scoped=true&"
import script from "./background.vue?vue&type=script&lang=ts&"
export * from "./background.vue?vue&type=script&lang=ts&"
import style0 from "./background.vue?vue&type=style&index=0&id=4e62acd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e62acd6",
  null
  
)

export default component.exports